import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { activateSignal, cancelPendingForBlock, getDataValue, setExecVar, setDataValue, addPending, getExecVar } from '../../runtime.js';
import { sigOut, sigIn, sockOut, sockIn } from '../../sockets.js';
import { fgInt } from '../../custom-types/fg-integer.js';

const DELAY_SEQ_KEY = "__delaySeq";
const DELAY_KEY = (idx) => `__delay_${idx}`;
const setDelayDef = {
  type: FgBlockType.SetDelay,
  build: () => ({
    dataIn: [sockIn("duration", FgType.Number, 0)],
    dataOut: [sockOut("lastDelayIndex", FgType.Integer)],
    signalIn: [sigIn("in"), sigIn("cancel")],
    signalOut: [sigOut("out"), sigOut("done"), sigOut("error")]
  }),
  updateOutputs(block, ctx) {
    setDataValue(ctx, block, "lastDelayIndex", fgInt(getExecVar(ctx, block, "lastDelayIndex", -1)));
  },
  execute(block, ctx, env, incomingSignal) {
    if (incomingSignal === "cancel") {
      for (const task2 of ctx.pending) {
        if (task2.blockId === block.id && !task2.canceled && !task2.done) {
          const idx = task2.state.delayIndex;
          delete ctx.executionVariables[DELAY_KEY(idx)];
        }
      }
      cancelPendingForBlock(ctx, block);
      return;
    }
    const duration = getDataValue(ctx, env, block, "duration");
    if (!isFinite(duration) || isNaN(duration) || duration < 0) {
      activateSignal(ctx, env, block, "error");
      return;
    }
    const seq = (ctx.executionVariables[DELAY_SEQ_KEY] ?? -1) + 1;
    ctx.executionVariables[DELAY_SEQ_KEY] = seq;
    setExecVar(ctx, block, "lastDelayIndex", seq);
    setDataValue(ctx, block, "lastDelayIndex", fgInt(seq));
    const task = addPending(ctx, block, { remainingMs: duration * 1e3, delayIndex: seq });
    ctx.executionVariables[DELAY_KEY(seq)] = task;
    activateSignal(ctx, env, block, "out");
  },
  onTick(block, ctx, env, deltaMs, task) {
    const remaining = task.state.remainingMs - deltaMs;
    if (remaining <= 0) {
      task.done = true;
      const idx = task.state.delayIndex;
      delete ctx.executionVariables[DELAY_KEY(idx)];
      activateSignal(ctx, env, block, "done");
    } else {
      task.state.remainingMs = remaining;
    }
  },
  cancelPending(_block, ctx) {
    for (const key of Object.keys(ctx.executionVariables)) {
      if (key.startsWith("__delay_")) {
        const task = ctx.executionVariables[key];
        if (task?.canceled) {
          delete ctx.executionVariables[key];
        }
      }
    }
  }
};

export { setDelayDef };
//# sourceMappingURL=set-delay.js.map
